// @flow
import { reducer as form } from "redux-form"
import { routerReducer as routing } from "react-router-redux"
import splitsterReducer from "splitster-redux"

import account from "../../mmb/scenes/Account/services/AccountDuck"
import currencies from "./currencies/index"
import cookiesBanner from "../components/Cookies/services/reducer"
import helpCenter from "../scenes/HelpCenter/services/helpCenterDuck"
import smartFAQ from "../modules/SmartFAQ/services/SmartFAQDuck"
import history from "./history/historyDuck"
import modals from "./modals/reducer"
import notice from "./notice"
import options from "./options/reducer"
import page from "./page/index"
import params from "./params/index"
import query from "./query/index"
import remoteConfig from "./remoteConfig/index"
import sideNav from "./sideNav/index"
import staticData from "./staticData/index"
import translations from "./intl/index"
import trips from "./trips/index"
import user from "./user/index"
import watchdog from "common/services/watchdog/watchdogReducer"
import window from "./window/index"
import starred from "./starred/starredDuck"

const defaultReducer = {
  account,
  countries: (state: {} = {}) => state,
  currencies,
  form,
  helpCenter,
  history,
  modals,
  notice,
  options,
  page,
  params,
  query,
  routing,
  sideNav,
  staticData,
  translations,
  trips,
  user,
  watchdog,
  window,
  cookiesBanner,
  smartFAQ,
  splitster: splitsterReducer,
  splitsterConfig: (state: {} = {}) => state,
  remoteConfig,
  starred,
}

export default defaultReducer
